<template>
	<slot :status="data" />
</template>

<script setup>
	const {confirmSubscribe} = useNewsletter();
	const data = ref(null);

	try {
		await confirmSubscribe().then(res => {
			data.value = res.data;
		});
	} catch (err) {
		useLog(err, 'error');
	}
</script>
